
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AppDropdown',
  setup() {
    const dropped = ref(false)

    function collapse() {
      document.body.removeEventListener('click', collapse, true)
      dropped.value = false
    }

    function toggle() {
      if (dropped.value) {
        collapse()
      } else {
        dropped.value = true
        document.body.addEventListener('click', collapse, true)
      }
    }

    return { dropped, toggle }
  }
})
